const NOME_MAX_LENGTH = 40;

function segmentosUnicos(lista) {
  const vistos = new Set();
  const saida = [];
  (Array.isArray(lista) ? lista : []).forEach(item => {
    const id = String(item || "")
      .trim()
      .toLowerCase();
    if (!id || vistos.has(id)) {
      return;
    }
    vistos.add(id);
    saida.push(id);
  });
  return saida;
}

export function normalizarConfig(config) {
  const compras = config && config.compras ? config.compras : {};
  const vendas = config && config.vendas ? config.vendas : {};
  const nome = config && config.nome != null ? String(config.nome) : "";
  return {
    nome,
    compras: {
      habilitado: Boolean(compras.habilitado),
      segmentos: segmentosUnicos(compras.segmentos)
    },
    vendas: {
      habilitado: Boolean(vendas.habilitado)
    }
  };
}

export function configParaPayload(draft) {
  const config = normalizarConfig(draft);
  const nome = config.nome.trim().slice(0, NOME_MAX_LENGTH);
  return {
    nome: nome ? nome : null,
    compras: {
      habilitado: config.compras.habilitado,
      segmentos: config.compras.segmentos
    },
    vendas: {
      habilitado: config.vendas.habilitado
    }
  };
}

export function mensagemErroApi(err) {
  const data = err && err.response && err.response.data;
  const message = data && (data.error || data.message);
  if (typeof message === "string" && message.trim()) {
    return message.replace(/<[^>]*>/g, "").trim();
  }
  return "Não foi possível salvar a configuração do assistente.";
}
